import { FieldError, Label, RequiredMark, Wrapper } from './FloatingField.styles';
import type { FloatingFieldProps } from './FloatingField.types';

export function FloatingField({
  label,
  hasValue,
  error,
  required = true,
  children,
}: FloatingFieldProps) {
  return (
    <Wrapper>
      {hasValue && (
        <Label>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </Label>
      )}
      {children}
      {error && <FieldError>{error}</FieldError>}
    </Wrapper>
  );
}
